import { createContext, useContext, useState } from "react";

const translations = {
  de: {
    nav: { shop: "Kollektion", how: "So geht's", contact: "Kontakt", admin: "Admin", menu: "Menü öffnen" },
    hero: {
      kicker: "Archiv-Resale · Est. 2026",
      lines: ["MARKEN-", "STREETWEAR.", "NEU & VINTED."],
      sub: "Kuratierte Brand-Klamotten — von seltenen Vinted-Funden bis brandneu mit Tag. Jedes Piece nur 1x auf Lager. Kauf läuft sicher über unser Vinted-Profil @hellovintora.",
      cta: "Kollektion entdecken",
      ctaSecondary: "So funktioniert's",
      stats: [["1/1", "Unikate"], ["24h", "Antwortzeit"], ["100%", "Originalware"]],
      scroll: "Scroll",
    },
    marquee: ["HELLOVINTORA ARCHIVE", "RARE STREETWEAR", "AUTHENTIC VINTED & BRAND NEW", "SICHER ÜBER VINTED KAUFEN"],
    catalog: {
      kicker: "Das Archiv",
      title: "Aktuelle Drops",
      search: "Suche nach Marke oder Piece…",
      all: "Alle",
      allConditions: "Alle Zustände",
      sort: { featured: "Neueste zuerst", price_asc: "Preis: aufsteigend", price_desc: "Preis: absteigend" },
      empty: "Keine Pieces gefunden.",
      reset: "Filter zurücksetzen",
      count: "Pieces im Archiv",
    },
    conditions: { neu: "Neu", wie_neu: "Wie neu", vinted: "Vinted" },
    product: {
      size: "Größe",
      condition: "Zustand",
      price: "Preis",
      order: "Auf Vinted kaufen",
      vintedNote: "Du wirst zu unserem Vinted-Profil @hellovintora weitergeleitet — sicher kaufen mit Vinted-Käuferschutz.",
      shipping: "Versand in 3–5 Tagen",
      askInstagram: "Frage per Instagram",
      emailCta: "Frage per E-Mail",
      details: "Details",
      sold: "Verkauft",
      available: "Verfügbar",
      reserved: "Reserviert",
      reservedNote: "Dieses Piece ist bereits reserviert — schreib uns, falls es wieder frei wird.",
      oneOfOne: "1/1 — nur ein Stück auf Lager",
      unique: "1/1 Unikat",
      copied: "DM-Text kopiert — einfach in Instagram einfügen",
      close: "Schließen",
    },
    order: {
      title: "Bestellen",
      name: "Dein Name",
      email: "Deine E-Mail",
      address: "Deine Versandadresse",
      submit: "Verbindlich bestellen",
      sending: "Wird gesendet…",
      error: "Bestellung fehlgeschlagen — versuch es erneut.",
      done: "Reserviert!",
      doneSub: "Das Piece ist 48 Stunden für dich reserviert. Überweise jetzt den Betrag — sobald die Zahlung da ist, geht dein Piece in den Versand.",
      bankTitle: "Überweisung an",
      holder: "Kontoinhaber",
      iban: "IBAN",
      bank: "Bank",
      amount: "Betrag",
      reference: "Verwendungszweck",
      copy: "Kopieren",
      copied: "Kopiert",
      note: "Wichtig: Überweise nur mit diesem Verwendungszweck, damit wir deine Zahlung zuordnen können. Du bekommst eine Bestätigung per E-Mail.",
      back: "Zurück zum Piece",
    },
    how: {
      kicker: "Der Prozess",
      title: "So einfach geht's",
      steps: [
        ["Piece aussuchen", "Stöbere durch das Archiv und finde dein Grail — jedes Piece ist ein 1/1 Unikat."],
        ["Auf Vinted kaufen", "Ein Klick bringt dich zu unserem Vinted-Profil @hellovintora — dort kaufst du sicher mit Käuferschutz."],
        ["Versand & fertig", "Nach dem Kauf auf Vinted geht dein Piece direkt in den Versand — in 3–5 Tagen ist es bei dir."],
      ],
    },
    drop: {
      kicker: "Coming Soon",
      title: "Nächster Drop",
      days: "Tage",
      hours: "Std",
      mins: "Min",
      secs: "Sek",
      live: "DROP IST LIVE",
      liveSub: "Der neue Drop ist da — sichere dir die Pieces, bevor sie weg sind.",
      cta: "Zum Drop",
    },
    lookbook: { kicker: "Lookbook", title: "Shop the Look", pieces: "Pieces in diesem Look" },
    notify: {
      title: "Drop-Alarm",
      sub: "Trag dich ein und erfahre als Erste:r, wenn der Drop live geht.",
      placeholder: "Deine E-Mail",
      button: "Benachrichtige mich",
      sending: "Moment…",
      success: "Du bist dabei! Wir schreiben dir beim Drop.",
      error: "Eintragen fehlgeschlagen — versuch es nochmal.",
      done: "Du stehst auf der Liste.",
    },
    contact: {
      kicker: "Kontakt",
      title: "Frag dein Piece an",
      sub: "Frage zu einem Piece, einer Größe oder dem Zustand? Schreib uns — wir antworten in unter 24 Stunden.",
      name: "Dein Name",
      email: "Deine E-Mail",
      message: "Deine Nachricht",
      send: "Nachricht senden",
      sending: "Wird gesendet…",
      success: "Nachricht gesendet! Wir melden uns per E-Mail bei dir.",
      error: "Senden fehlgeschlagen — versuch es gleich nochmal.",
      prefill: "Anfrage zu",
      shipping: "Versanddauer: 3–5 Tage nach dem Kauf.",
    },
    footer: {
      tagline: "Kuratiertes Streetwear-Archiv. Neu, wie neu & echte Vinted-Funde.",
      rights: "Alle Rechte vorbehalten.",
      payment: "Verkauf über Vinted · @hellovintora",
    },
    admin: {
      loginTitle: "Admin Login",
      loginSub: "hellovintora — Backend Zugang",
      email: "E-Mail",
      password: "Passwort",
      login: "Einloggen",
      loggingIn: "Wird geprüft…",
      loginError: "Login fehlgeschlagen — Zugangsdaten prüfen.",
      googleLogin: "Mit Google anmelden",
      orDivider: "oder",
      backToSite: "Zurück zur Website",
      dashboard: "Dashboard",
      products: "Produkte",
      messages: "Nachrichten",
      addProduct: "Neues Produkt",
      editProduct: "Produkt bearbeiten",
      logout: "Ausloggen",
      fields: { title: "Titel", brand: "Marke", category: "Kategorie", condition: "Zustand", size: "Größe", price: "Preis (€)", image: "Produktfoto", descDe: "Beschreibung (DE)", descEn: "Beschreibung (EN)", status: "Status" },
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      delete: "Löschen",
      confirmDelete: "Produkt wirklich löschen?",
      noMessages: "Noch keine Nachrichten eingegangen.",
      saved: "Gespeichert",
      deleted: "Gelöscht",
      loadError: "Laden fehlgeschlagen",
      sold: "Verkauft",
      available: "Verfügbar",
      reserved: "Reserviert",
      statuses: { available: "Verfügbar", reserved: "Reserviert", sold: "Verkauft" },
      dropTab: "Drop",
      dropSettings: "Drop-Countdown",
      dropEnabled: "Countdown auf der Website anzeigen",
      dropDate: "Drop-Datum & Uhrzeit",
      dropTitleDe: "Titel (DE)",
      dropTitleEn: "Titel (EN)",
      dropSaved: "Drop-Einstellungen gespeichert",
      upload: "Foto hochladen",
      uploading: "Lädt hoch…",
      uploadOr: "oder Bild-URL einfügen",
      uploadError: "Upload fehlgeschlagen — nur JPG/PNG/WEBP bis 10 MB",
      statsTab: "Statistik",
      stats: { views: "Aufrufe", ig: "IG-Klicks", vinted: "Vinted-Klicks", email: "Anfragen", empty: "Noch keine Statistik-Daten — sie entstehen, sobald Besucher Pieces öffnen und anfragen." },
      subscribers: "Drop-Fans",
      noSubscribers: "Noch keine Anmeldungen für den Drop-Alarm.",
      looksTab: "Looks",
      addLook: "Neuer Look",
      editLook: "Look bearbeiten",
      lookTitleDe: "Titel (DE)",
      lookTitleEn: "Titel (EN)",
      lookDescDe: "Beschreibung (DE)",
      lookDescEn: "Beschreibung (EN)",
      lookImage: "Look-Foto",
      lookProducts: "Pieces im Look",
      noLooks: "Noch keine Looks angelegt.",
      confirmDeleteLook: "Look wirklich löschen?",
      ordersTab: "Bestellungen",
      bankTab: "Bank",
      orders: {
        empty: "Noch keine Bestellungen.",
        buyer: "Käufer",
        address: "Adresse",
        ref: "Verwendungszweck",
        ordered: "Bestellt",
        reservedUntil: "Reserviert bis",
        markPaid: "Zahlung erhalten",
        cancel: "Stornieren",
        pending: "Ausstehend",
        paid: "Bezahlt",
        cancelled: "Storniert",
      },
      bank: {
        title: "Bankverbindung",
        sub: "Wird Käufern nach der Bestellung zur Überweisung angezeigt.",
        holder: "Kontoinhaber",
        iban: "IBAN",
        name: "Bankname",
        bic: "BIC (optional)",
        saved: "Bankdaten gespeichert",
      },
    },
    dm: (p) => `Hi hellovintora! Frage zu "${p.title}" (${p.code}, Größe ${p.size}, ${p.price}€): `,
  },
  en: {
    nav: { shop: "Archive", how: "How it works", contact: "Contact", admin: "Admin", menu: "Open menu" },
    hero: {
      kicker: "Archive Resale · Est. 2026",
      lines: ["BRAND", "STREETWEAR.", "NEW & VINTED."],
      sub: "Curated brand clothing — from rare Vinted finds to brand new with tags. Every piece is a one-off. Buying runs securely through our Vinted profile @hellovintora.",
      cta: "Explore the archive",
      ctaSecondary: "How it works",
      stats: [["1/1", "one-offs"], ["24h", "reply time"], ["100%", "authentic"]],
      scroll: "Scroll",
    },
    marquee: ["HELLOVINTORA ARCHIVE", "RARE STREETWEAR", "AUTHENTIC VINTED & BRAND NEW", "BUY SAFELY VIA VINTED"],
    catalog: {
      kicker: "The Archive",
      title: "Current Drops",
      search: "Search brand or piece…",
      all: "All",
      allConditions: "All conditions",
      sort: { featured: "Newest first", price_asc: "Price: low to high", price_desc: "Price: high to low" },
      empty: "No pieces found.",
      reset: "Reset filters",
      count: "pieces in the archive",
    },
    conditions: { neu: "New", wie_neu: "Like new", vinted: "Vinted" },
    product: {
      size: "Size",
      condition: "Condition",
      price: "Price",
      order: "Buy on Vinted",
      vintedNote: "You'll be redirected to our Vinted profile @hellovintora — buy safely with Vinted buyer protection.",
      shipping: "Ships in 3–5 days",
      askInstagram: "Ask via Instagram",
      emailCta: "Ask by email",
      details: "Details",
      sold: "Sold",
      available: "Available",
      reserved: "Reserved",
      reservedNote: "This piece is already reserved — message us in case it becomes available again.",
      oneOfOne: "1/1 — only one piece in stock",
      unique: "1/1 unique",
      copied: "Message copied — just paste it in Instagram",
      close: "Close",
    },
    order: {
      title: "Order",
      name: "Your name",
      email: "Your email",
      address: "Your shipping address",
      submit: "Place binding order",
      sending: "Sending…",
      error: "Order failed — please try again.",
      done: "Reserved!",
      doneSub: "The piece is reserved for you for 48 hours. Transfer the amount now — once payment arrives, your piece ships.",
      bankTitle: "Transfer to",
      holder: "Account holder",
      iban: "IBAN",
      bank: "Bank",
      amount: "Amount",
      reference: "Reference",
      copy: "Copy",
      copied: "Copied",
      note: "Important: only transfer with this reference so we can match your payment. You will receive a confirmation by email.",
      back: "Back to the piece",
    },
    how: {
      kicker: "The process",
      title: "How it works",
      steps: [
        ["Pick your piece", "Browse the archive and find your grail — every piece is a 1/1 unique."],
        ["Buy on Vinted", "One click takes you to our Vinted profile @hellovintora — buy safely with buyer protection."],
        ["Shipping & done", "After buying on Vinted your piece ships right away — it reaches you in 3–5 days."],
      ],
    },
    drop: {
      kicker: "Coming Soon",
      title: "Next Drop",
      days: "Days",
      hours: "Hrs",
      mins: "Min",
      secs: "Sec",
      live: "DROP IS LIVE",
      liveSub: "The new drop is here — cop the pieces before they're gone.",
      cta: "Shop the drop",
    },
    lookbook: { kicker: "Lookbook", title: "Shop the Look", pieces: "Pieces in this look" },
    notify: {
      title: "Drop alert",
      sub: "Sign up and be the first to know when the drop goes live.",
      placeholder: "Your email",
      button: "Notify me",
      sending: "One moment…",
      success: "You're in! We'll email you at the drop.",
      error: "Sign-up failed — please try again.",
      done: "You're on the list.",
    },
    contact: {
      kicker: "Contact",
      title: "Enquire about a piece",
      sub: "Question about a piece, a size or the condition? Write to us — we reply within 24 hours.",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent! We'll get back to you by email.",
      error: "Sending failed — please try again.",
      prefill: "Enquiry about",
      shipping: "Shipping time: 3–5 days after purchase.",
    },
    footer: {
      tagline: "Curated streetwear archive. New, like-new & real Vinted finds.",
      rights: "All rights reserved.",
      payment: "Sold via Vinted · @hellovintora",
    },
    admin: {
      loginTitle: "Admin Login",
      loginSub: "hellovintora — backend access",
      email: "Email",
      password: "Password",
      login: "Log in",
      loggingIn: "Checking…",
      loginError: "Login failed — check your credentials.",
      googleLogin: "Sign in with Google",
      orDivider: "or",
      backToSite: "Back to website",
      dashboard: "Dashboard",
      products: "Products",
      messages: "Messages",
      addProduct: "New product",
      editProduct: "Edit product",
      logout: "Log out",
      fields: { title: "Title", brand: "Brand", category: "Category", condition: "Condition", size: "Size", price: "Price (€)", image: "Product photo", descDe: "Description (DE)", descEn: "Description (EN)", status: "Status" },
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: "Really delete this product?",
      noMessages: "No messages yet.",
      saved: "Saved",
      deleted: "Deleted",
      loadError: "Failed to load",
      sold: "Sold",
      available: "Available",
      reserved: "Reserved",
      statuses: { available: "Available", reserved: "Reserved", sold: "Sold" },
      dropTab: "Drop",
      dropSettings: "Drop countdown",
      dropEnabled: "Show countdown on the website",
      dropDate: "Drop date & time",
      dropTitleDe: "Title (DE)",
      dropTitleEn: "Title (EN)",
      dropSaved: "Drop settings saved",
      upload: "Upload photo",
      uploading: "Uploading…",
      uploadOr: "or paste image URL",
      uploadError: "Upload failed — JPG/PNG/WEBP up to 10 MB only",
      statsTab: "Statistics",
      stats: { views: "Views", ig: "IG clicks", vinted: "Vinted clicks", email: "Enquiries", empty: "No stats yet — they appear once visitors open and enquire about pieces." },
      subscribers: "Drop fans",
      noSubscribers: "No drop alert sign-ups yet.",
      looksTab: "Looks",
      addLook: "New look",
      editLook: "Edit look",
      lookTitleDe: "Title (DE)",
      lookTitleEn: "Title (EN)",
      lookDescDe: "Description (DE)",
      lookDescEn: "Description (EN)",
      lookImage: "Look photo",
      lookProducts: "Pieces in this look",
      noLooks: "No looks yet.",
      confirmDeleteLook: "Really delete this look?",
      ordersTab: "Orders",
      bankTab: "Bank",
      orders: {
        empty: "No orders yet.",
        buyer: "Buyer",
        address: "Address",
        ref: "Reference",
        ordered: "Ordered",
        reservedUntil: "Reserved until",
        markPaid: "Payment received",
        cancel: "Cancel",
        pending: "Pending",
        paid: "Paid",
        cancelled: "Cancelled",
      },
      bank: {
        title: "Bank details",
        sub: "Shown to buyers after ordering for the bank transfer.",
        holder: "Account holder",
        iban: "IBAN",
        name: "Bank name",
        bic: "BIC (optional)",
        saved: "Bank details saved",
      },
    },
    dm: (p) => `Hi hellovintora! Question about "${p.title}" (${p.code}, size ${p.size}, €${p.price}): `,
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("vintora_lang") || "de");
  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("vintora_lang", l);
  };
  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
